/** @format */

import MainHeader from "../Components/MainHeader";
import { useState, useEffect } from "react";
import './Rank.css';

const Rank = () => {
    const parentFunction = (x) => {};

    const [distanceTop5, setDistanceTop5] = useState([]);
    const [elevationTop5, setElevationTop5] = useState([]);
    const [rideDistanceTop5, setRideDistanceTop5] = useState([]);
    const [climberTop5, setClimberTop5] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            // sessionStorage에서 데이터 가져오기
            const storedDistance = sessionStorage.getItem('distanceTop5');
            const storedElevation = sessionStorage.getItem('elevationTop5');
            const storedRideDistance = sessionStorage.getItem('rideDistanceTop5');
            const storedClimber = sessionStorage.getItem('climberTop5');

            if (storedDistance && storedElevation && storedRideDistance && storedClimber) {
                // sessionStorage에 저장된 데이터가 있으면 해당 데이터 사용
                setDistanceTop5(JSON.parse(storedDistance));
                setElevationTop5(JSON.parse(storedElevation));
                setRideDistanceTop5(JSON.parse(storedRideDistance));
                setClimberTop5(JSON.parse(storedClimber));
            } else {
                // sessionStorage에 저장된 데이터가 없으면 fetch 요청하여 데이터 가져오기
                const response1 = await fetch(process.env.REACT_APP_API_ADDRESS + '/distance');
                const distance = await response1.json();
                setDistanceTop5(distance);
                sessionStorage.setItem('distanceTop5', JSON.stringify(distance));

                const response2 = await fetch(process.env.REACT_APP_API_ADDRESS + '/elevation');
                const elevation = await response2.json();
                setElevationTop5(elevation);
                sessionStorage.setItem('elevationTop5', JSON.stringify(elevation));

                const response3 = await fetch(process.env.REACT_APP_API_ADDRESS + '/rideDistance');
                const rideDistance = await response3.json();
                setRideDistanceTop5(rideDistance);
                sessionStorage.setItem('rideDistanceTop5', JSON.stringify(rideDistance));

                const response4 = await fetch(process.env.REACT_APP_API_ADDRESS + '/climber');
                const climber = await response4.json();
                setClimberTop5(climber);
                sessionStorage.setItem('climberTop5', JSON.stringify(climber));
            }
        };

        fetchData();
    }, []);

   
    return (
        <div>
            <MainHeader parentFunction={parentFunction} />
            <div>
                <p className="title1">LeaderBoard</p>
                <p style={{fontSize: '1.5vw', textAlign: 'center', margin: '0'}}>각 항목들의 Top 5 유저입니다.</p>
            </div>
            <div className="rank1">
                <p style={{fontSize : '2vw', fontWeight: 'bold', margin:'0', marginBottom:'1vw', marginTop: '3vw'}}>누적 거리 Top 5</p>
                {distanceTop5.map((it) => (
                <div className="column">
                    <img src={it.profile}/>
                    <p>{it.name}</p>
                    <p>{(it.field/1000).toFixed(2)}km</p>
                </div>
              ))}

                <p style={{fontSize : '2vw', fontWeight: 'bold', margin:'0', marginBottom:'1vw', marginTop: '3vw'}}>누적 상승고도 Top 5</p>
                {elevationTop5.map((it) => (
                <div className="column">
                    <img src={it.profile}/>
                    <p>{it.name}</p>
                    <p>{(it.field)}m</p>
                </div>
              ))}

                <p style={{fontSize : '2vw', fontWeight: 'bold', margin:'0', marginBottom:'1vw',marginTop: '3vw'}}>Best 클라이머 (누적거리 / 상승고도)</p>
                {climberTop5.map((it) => (
                <div className="column">
                    <img src={it.profile}/>
                    <p>{it.name}</p>
                    <p>{((it.field.distance/100) / it.field.elevation).toFixed(4)}</p>
                </div>
              ))}

                <p style={{fontSize : '2vw', fontWeight: 'bold', margin:'0', marginBottom:'1vw', marginTop: '3vw'}}>최장거리 라이딩</p>
                {rideDistanceTop5.map((it) => (
                <div className="column">
                    <img src={it.userProfile}/>
                    <p>{it.userName}</p>
                    <p>{it.rideName}</p>
                    <p>{it.date}</p>
                    <p>{(it.distance).toFixed(2)}km</p>
                    <p>{it.elevation}m</p>
                    <p>{(it.avgSpeed).toFixed(2)}km/h</p>
                </div>
              ))}
              
            </div>
        </div>
    )
};

export default Rank;